import artworkFrag from "./Artwork";
import contactFrag from "./Contact";
import Currency from "./Currency";
import instance from "./Instance";
import OfferStatus from "./OfferStatus";

const Offer = (props = {}) => {
  // Handle case where props is true (include defaults) vs object (use configured fields)
  const includeDefaults = props === true || Object.keys(props).length === 0;
  const propsObj = typeof props === "object" && props !== null ? props : {};

  const {
    artwork = false,
    contact = false,
    currency = false,
    hold = false,
    status = false,
    amount = includeDefaults,
    contactId = includeDefaults,
    currencyId = includeDefaults,
    date = includeDefaults,
    dateClosed = includeDefaults,
    exchange = includeDefaults,
    holdId = includeDefaults,
    holdDate = includeDefaults,
    notes = includeDefaults,
    priority = includeDefaults,
    rank = includeDefaults,
    statusId = includeDefaults,
    tbiAmount = includeDefaults,
    tbiDate = includeDefaults,
    transparency = includeDefaults,
    user = includeDefaults,
    updatedAt = includeDefaults,
    projectCode = includeDefaults,
  } = propsObj;

  return `
  id
  ${amount ? `amount` : ""}
  ${
    artwork
      ? `artwork {
      ${artworkFrag(artwork)}
    }`
      : ""
  }
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  ${contactId ? `contactId` : ""}
  ${
    currency
      ? `currency {
      ${Currency}
    }`
      : ""
  }
  ${currencyId ? `currencyId` : ""}
  ${date ? `date` : ""}
  ${dateClosed ? `dateClosed` : ""}
  ${exchange ? `exchange` : ""}
  ${
    hold
      ? `hold {
      ${instance(hold)}
    }`
      : ""
  }
  ${holdId ? `holdId` : ""}
  ${holdDate ? `holdDate` : ""}
  ${notes ? `notes` : ""}
  ${priority ? `priority` : ""}
  ${rank ? `rank` : ""}
  ${
    status
      ? `status {
      ${OfferStatus}
    }`
      : ""
  }
  ${statusId ? `statusId` : ""}
  ${tbiAmount ? `tbiAmount` : ""}
  ${tbiDate ? `tbiDate` : ""}
  ${transparency ? `transparency` : ""}
  ${user ? `user` : ""}
  ${updatedAt ? `updatedAt` : ""}
  ${projectCode ? `projectCode` : ""}
`;
};

export default Offer;
